import { lazy } from 'react'
import { registerEditor } from '../editor-registry.js'

const LazyHtmlEditor = lazy(() =>
  import('../../ui/HtmlEditor.js').then(m => ({ default: m.HtmlEditor }))
)

registerEditor({
  notifiesFileGone: true, // #823: FileStateBanner, from the room's close
  family: 'html-page',
  extensions: ['html', 'htm'],
  name: 'HTML Editor',
  component: LazyHtmlEditor,
  maxEditableSize: 1024 * 1024, // 1 MB
})
